import React, { useState, createContext, useContext } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import RoleMastery from './components/RoleMastery';
import ContentProduction from './components/ContentProduction';
import WorkflowEngine from './components/WorkflowEngine';
import EngagementManagement from './components/EngagementManagement';
import ReportingAnalytics from './components/ReportingAnalytics';
import ToolsTemplates from './components/ToolsTemplates';
import RemoteWork from './components/RemoteWork';
import MultiBrandCenter from './components/MultiBrandCenter';
import ContentPipeline from './components/ContentPipeline';
import TrendResearch from './components/TrendResearch';
import { NotificationProvider, createGlobalAlert, createGlobalConfirm } from './components/NotificationSystem';
import './App.css';

// Create context for brand synchronization
const BrandContext = createContext();
export const useBrandContext = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrandContext must be used within a BrandProvider');
  }
  return context;
};

const BrandProvider = ({ children }) => {
  const [brands, setBrands] = useState([
    '7-Eleven',
    'Aperol',
    'CELSIUS',
    'OLIPOP',
    'PBR',
    'Arrowhead Water',
    'CHOMPS'
  ]);

  const addBrand = (brandName) => {
    if (brandName.trim() && !brands.includes(brandName.trim())) {
      setBrands(prev => [...prev, brandName.trim()]);
    }
  };

  const removeBrand = (brandToRemove) => {
    if (brands.length > 1) {
      setBrands(prev => prev.filter(brand => brand !== brandToRemove));
    }
  };

  return (
    <BrandContext.Provider value={{ brands, addBrand, removeBrand }}>
      {children}
    </BrandContext.Provider>
  );
};

function App() {
  return (
    <BrandProvider>
      <NotificationProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-beige via-white to-[#FAF7F2] font-sf-pro mobile-safe-area">
            <Navigation />
            <main className="flex-1 lg:ml-72 min-h-screen">
              <div className="relative">
                {/* Background decoration */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                  <div className="absolute -top-40 -right-40 w-80 h-80 bg-gold/10 rounded-full blur-3xl floating"></div>
                  <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-apache/10 rounded-full blur-3xl floating" style={{ animationDelay: '3s' }}></div>
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brown/5 rounded-full blur-3xl"></div>
                </div>

                {/* Content */}
                <div className="relative mobile-content-padding pt-20 lg:pt-10">
                  <Routes>
                    <Route path="/" element={<Navigate to="/role-mastery" replace />} />
                    <Route path="/role-mastery" element={<RoleMastery />} />
                    <Route path="/content-production" element={<ContentProduction />} />
                    <Route path="/workflow-engine" element={<WorkflowEngine />} />
                    <Route path="/engagement-management" element={<EngagementManagement />} />
                    <Route path="/reporting-analytics" element={<ReportingAnalytics />} />
                    <Route path="/tools-templates" element={<ToolsTemplates />} />
                    <Route path="/remote-work" element={<RemoteWork />} />
                    <Route path="/multi-brand-center" element={<MultiBrandCenter />} />
                    <Route path="/content-pipeline" element={<ContentPipeline />} />
                    <Route path="/trend-research" element={<TrendResearch />} />
                  </Routes>
                </div>
              </div>
            </main>
          </div>
        </Router>
      </NotificationProvider>
    </BrandProvider>
  );
}

export default App;